import React from 'react';
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Text, VStack, } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import COLORS from '../../../../../constants/colors';
import EventGroup from '../event-group/index.web'; // Import the next component we'll create
const EventTypeList = ({ data, onDocumentPress, }) => {
    const { t } = useTranslation();
    if (!data || Object.keys(data).length === 0) {
        // Handle empty state or loading state if needed
        return (<Text p={4}>No documents found for the selected event criteria.</Text>);
    }
    const eventTypes = Object.keys(data);
    // Check the FONTS definition - assuming it maps to fontWeight='semibold' and fontSize='16px'
    const eventTypeTextStyle = { fontWeight: 'semibold', fontSize: '16px' };
    const getDocumentCountText = (count) => {
        return count === 1 ? `(${count} document)` : `(${count} documents)`;
    };
    return (<Accordion allowMultiple width="100%" defaultIndex={eventTypes.length === 1 ? [0] : undefined} // Auto-open if single event type
    >
      {eventTypes.map((eventType, index) => {
            const eventGroups = data ? data[eventType] : {};
            const eventTitles = Object.keys(eventGroups);
            let totalDocumentsInEventType = 0;
            eventTitles.forEach(title => {
                totalDocumentsInEventType += eventGroups[title]?.length || 0;
            });
            return (<AccordionItem key={index} border="none" borderBottomWidth="1px" borderColor="gray.200">
            <h2>
              <AccordionButton py={3} _hover={{ bg: 'gray.50' }} _expanded={{ bg: 'gray.50' }}>
                <AccordionIcon mr={2}/>
                <Box flex="1" textAlign="left">
                  <Text {...eventTypeTextStyle}>{`${t(eventType)} ${getDocumentCountText(totalDocumentsInEventType)}`}</Text>
                </Box>
              </AccordionButton>
            </h2>
            <AccordionPanel pb={2} pt={1} px={2} bg={COLORS.White.T500.value}>
              {eventTitles.length > 0 ? (<VStack align="stretch" spacing={2}>
                  {eventTitles.map((eventTitle, groupIndex) => (<EventGroup key={groupIndex} title={eventTitle} documents={eventGroups[eventTitle]} onDocumentPress={onDocumentPress}/>))}
                </VStack>) : (<Text px={2} py={2} color="gray.500">
                  No specific events found for this type.
                </Text>)}
            </AccordionPanel>
          </AccordionItem>);
        })}
    </Accordion>);
};
export default EventTypeList;
